(() => {
  const modal = document.querySelector('[data-pre-checkout-upsell]');

  if (!modal || modal.dataset.enabled !== 'true') {
    return;
  }

  const cards = Array.from(modal.querySelectorAll('[data-upsell-card]'));
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const mobileProductLimit = Math.max(1, Number(modal.dataset.mobileProductLimit || 6));
  const desktopProductLimit = Math.max(1, Number(modal.dataset.desktopProductLimit || 8));
  const checkoutButtonsSelector = 'button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout';
  const sessionKey = 'kickis-pre-checkout-upsell-seen';
  const continueButtons = modal.querySelectorAll('[data-upsell-continue]');
  const closeButtons = modal.querySelectorAll('[data-upsell-close]');
  const statusEl = modal.querySelector('[data-upsell-status]');
  let pendingCheckoutForm = null;
  let pendingCheckoutButton = null;
  let lastFocusedElement = null;

  if (!cards.length) {
    return;
  }

  const applyResponsiveCardLimit = () => {
    const limit = mobileQuery.matches ? mobileProductLimit : desktopProductLimit;
    cards.forEach((card, index) => {
      card.hidden = index >= limit;
    });
  };

  applyResponsiveCardLimit();
  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', applyResponsiveCardLimit);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(applyResponsiveCardLimit);
  }

  const setStatus = (message) => {
    if (statusEl) {
      statusEl.textContent = message || '';
    }
  };

  const focusFirstControl = () => {
    const focusTarget = modal.querySelector('[data-upsell-continue]') || modal.querySelector('button, a');
    if (focusTarget) {
      focusTarget.focus({ preventScroll: true });
    }
  };

  const openModal = () => {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pre-checkout-upsell-open');
    setStatus('');
    window.setTimeout(focusFirstControl, 0);
    cards.filter((card) => !card.hidden).forEach((card) => {
      document.dispatchEvent(new CustomEvent('kickis:analytics:event', {
        detail: {
          eventType: 'upsell_viewed',
          itemType: 'product',
          itemKey: `product:${card.dataset.productId}`,
          variantKey: String(card.dataset.variantId || ''),
          itemTitle: card.dataset.productTitle || '',
          itemUrl: card.dataset.productUrl || '',
          imageUrl: card.dataset.productImage || '',
          metadata: { recommendationContext: 'pre_checkout' },
        },
      }));
    });
  };

  const closeModal = () => {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pre-checkout-upsell-open');

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  const addCheckoutIntentInput = (form) => {
    if (!form || form.querySelector('input[name="checkout"][data-pre-checkout-hidden]')) {
      return;
    }

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = 'checkout';
    input.dataset.preCheckoutHidden = 'true';
    form.appendChild(input);
  };

  const proceedToCheckout = () => {
    sessionStorage.setItem(sessionKey, '1');
    closeModal();

    if (pendingCheckoutForm) {
      addCheckoutIntentInput(pendingCheckoutForm);
      HTMLFormElement.prototype.submit.call(pendingCheckoutForm);
      return;
    }

    window.location.href = '/checkout';
  };

  const shouldIntercept = (button) => {
    if (!button || button.disabled || button.dataset.preCheckoutBypass === 'true') {
      return false;
    }

    if (sessionStorage.getItem(sessionKey) === '1') {
      return false;
    }

    const form = button.form || button.closest('form');
    if (!form) {
      return false;
    }

    return true;
  };

  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest(checkoutButtonsSelector);

      if (!shouldIntercept(checkoutButton)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      pendingCheckoutButton = checkoutButton;
      pendingCheckoutForm = checkoutButton.form || checkoutButton.closest('form');
      openModal();
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter || pendingCheckoutButton;
      const isCheckoutSubmit = submitter && submitter.matches && submitter.matches(checkoutButtonsSelector);

      if (!isCheckoutSubmit || !shouldIntercept(submitter)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      pendingCheckoutButton = submitter;
      pendingCheckoutForm = event.target;
      openModal();
    },
    true
  );

  continueButtons.forEach((button) => {
    button.addEventListener('click', proceedToCheckout);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      sessionStorage.setItem(sessionKey, '1');
      closeModal();
    });
  });

  modal.addEventListener('click', (event) => {
    const productLink = event.target.closest('[data-upsell-card] a');
    if (productLink) {
      const card = productLink.closest('[data-upsell-card]');
      document.dispatchEvent(new CustomEvent('kickis:analytics:event', {
        detail: {
          eventType: 'upsell_clicked',
          itemType: 'product',
          itemKey: `product:${card.dataset.productId}`,
          variantKey: String(card.dataset.variantId || ''),
          itemTitle: card.dataset.productTitle || '',
          itemUrl: card.dataset.productUrl || '',
          imageUrl: card.dataset.productImage || '',
          metadata: { recommendationContext: 'pre_checkout' },
        },
      }));
    }
    if (event.target.matches('[data-upsell-overlay]')) {
      sessionStorage.setItem(sessionKey, '1');
      closeModal();
    }
  });

  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      sessionStorage.setItem(sessionKey, '1');
      closeModal();
    }
  });

  modal.querySelectorAll('[data-upsell-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      const variantId = button.dataset.variantId;
      const originalText = button.textContent;

      if (!variantId || button.disabled) {
        return;
      }

      button.disabled = true;
      button.textContent = button.dataset.loadingText || 'Lägger till...';
      setStatus('');

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1, properties: { '_Kickis-källa': 'pre_checkout' } }),
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        button.textContent = button.dataset.addedText || 'Tillagd';
        button.classList.add('button--secondary');
        setStatus(button.dataset.successMessage || 'Produkten har lagts till i varukorgen.');
        document.dispatchEvent(new CustomEvent('kickis:analytics:event', {
          detail: {
            eventType: 'upsell_added',
            itemType: 'product',
            itemKey: `product:${button.closest('[data-upsell-card]')?.dataset.productId || variantId}`,
            variantKey: String(variantId),
            quantity: 1,
            valueMinor: Number(button.closest('[data-upsell-card]')?.dataset.variantPrice || 0),
            currency: 'SEK',
            itemTitle: button.closest('[data-upsell-card]')?.dataset.productTitle || '',
            itemUrl: button.closest('[data-upsell-card]')?.dataset.productUrl || '',
            imageUrl: button.closest('[data-upsell-card]')?.dataset.productImage || '',
            metadata: { recommendationContext: 'pre_checkout' },
          },
        }));
      } catch (error) {
        button.disabled = false;
        button.textContent = originalText;
        setStatus(button.dataset.errorText || 'Det gick inte att lägga till produkten. Försök igen.');
      }
    });
  });
})();
